export const WalletStrategyEmitterEventType = {
    TransactionFail: 'transaction-fail',
    TransactionSigned: 'transaction-signed',
    TransactionSignStart: 'transaction-sign-start',
    TransactionBroadcastEnd: 'transaction-broadcast-end',
    WalletStrategyDisconnect: 'wallet-strategy-disconnect',
    TransactionBroadcastStart: 'transaction-broadcast-start',
    TransactionPreparationEnd: 'transaction-preparation-end',
    TransactionPreparationStart: 'transaction-preparation-start',
};
